"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var settings = function settings(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.58579 2.89979L10.1928 0.292786C10.3803 0.105315 10.6346 0 10.8998 0C11.165 0 11.4193 0.105315 11.6068 0.292786L14.2138 2.89979H17.8998C18.165 2.89979 18.4194 3.00514 18.6069 3.19268C18.7944 3.38022 18.8998 3.63457 18.8998 3.89979V7.58579L21.5068 10.1928C21.6943 10.3803 21.7996 10.6346 21.7996 10.8998C21.7996 11.165 21.6943 11.4193 21.5068 11.6068L18.8998 14.2138V17.8998C18.8998 18.165 18.7944 18.4194 18.6069 18.6069C18.4194 18.7944 18.165 18.8998 17.8998 18.8998H14.2138L11.6068 21.5068C11.4193 21.6943 11.165 21.7996 10.8998 21.7996C10.6346 21.7996 10.3803 21.6943 10.1928 21.5068L7.58579 18.8998H3.89979C3.63457 18.8998 3.38022 18.7944 3.19268 18.6069C3.00514 18.4194 2.89979 18.165 2.89979 17.8998V14.2138L0.292786 11.6068C0.105315 11.4193 0 11.165 0 10.8998C0 10.6346 0.105315 10.3803 0.292786 10.1928L2.89979 7.58579V3.89979C2.89979 3.63457 3.00514 3.38022 3.19268 3.19268C3.38022 3.00514 3.63457 2.89979 3.89979 2.89979H7.58579ZM10.8998 13.8998C11.6954 13.8998 12.4585 13.5837 13.0211 13.0211C13.5837 12.4585 13.8998 11.6954 13.8998 10.8998C13.8998 10.1041 13.5837 9.34107 13.0211 8.77847C12.4585 8.21586 11.6954 7.89979 10.8998 7.89979C10.1041 7.89979 9.34107 8.21586 8.77847 8.77847C8.21586 9.34107 7.89979 10.1041 7.89979 10.8998C7.89979 11.6954 8.21586 12.4585 8.77847 13.0211C9.34107 13.5837 10.1041 13.8998 10.8998 13.8998Z",
    fill: "#F4F4F9"
  }));
};
settings.defaultProps = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  height: 44px;\n  width: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var Button = function Button(_ref2) {
  var dotColor = _ref2.dotColor;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, dotColor ? /*#__PURE__*/_react.default.createElement(_ui.WithDot, {
    dot: /*#__PURE__*/_react.default.createElement(_ui.Dot, {
      color: dotColor,
      size: 10
    }),
    position: "top"
  }, /*#__PURE__*/_react.default.createElement(_ui.Svg, {
    as: settings
  })) : /*#__PURE__*/_react.default.createElement(_ui.Svg, {
    as: settings
  }));
};
exports.Button = Button;